<template>
  <div class="flexContainer columnContainer">
    <input
      v-model="keyword"
      v-on:input="getResults"
      placeholder="Gdzie chcesz iść?"
      autocomplete="off"
    />
    <div style="overflow-y: scroll">
      <article-preview
        style="cursor: pointer"
        :style="{ borderBottom: borderStyle }"
        class="flexContainer centerContainer"
        :class="{ selectedResult: result.id === selectedResultId }"
        v-for="result in results"
        :key="result.id"
        :title="result.title"
        :origin="origin"
        @selected_result="emitSelectedArticleId(result.id, result.title)"
      ></article-preview>
    </div>
  </div>
</template>

<script>
import ArticlePreview from "../preview.vue";

export default {
  props: {
    origin: {
      default: "createArticle",
      type: String,
    },
  },
  data() {
    return {
      keyword: "",
      results: [],
      selectedResultId: null,
    };
  },
  methods: {
    getResults() {
      this.$http.get("meta/?search=" + this.keyword).then((response) => {
        this.results = response.body;
      });
    },
    emitSelectedArticleId(articleId, articleTitle) {
      this.selectedResultId = articleId;
      this.$emit("form_update_notification", {
        articleId: articleId,
        articleTitle: articleTitle,
      });
    },
  },
  computed: {
    isFromCreateArticle() {
      return this.origin === "createArticle";
    },
    isFromSearchPopup() {
      return this.origin === "searchPopup";
    },
    borderStyle() {
      if (this.isFromCreateArticle) {
        return "1px solid #ffffff";
      } else {
        return "1px solid #000000";
      }
    },
  },
  components: {
    "article-preview": ArticlePreview,
  },
  created() {
    this.getResults();
  },
};
</script>

<style scoped>
.selectedResult {
  border: 2px solid #ffaf60 !important;
}

@media (max-width: 1000px) {
  input {
    display: none;
  }
}
</style>
